import PropTypes from "prop-types";
import React from "react";
import { Container, Card, CardBody } from "reactstrap";

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// i18n
import { withTranslation } from "react-i18next";
import ClientMenu from "./detail-menu";

const ClientMessages = props => {
  document.title = "Admin | Client Messages";

  // ================= MESSAGE DATA =================
  const messages = [
    {
      id: 1,
      senderType: "client",
      senderName: "John Smith",
      message: "I am unable to access my dashboard since yesterday.",
      date: "2025-01-05",
      time: "10:15 AM",
    },
    {
      id: 2,
      senderType: "support",
      senderName: "Support Agent A",
      message: "Thanks for reporting. We are checking this issue.",
      date: "2025-01-05",
      time: "11:00 AM",
    },
    {
      id: 3,
      senderType: "client",
      senderName: "John Smith",
      message: "Please update, this is urgent.",
      date: "2025-01-06",
      time: "09:30 AM",
    },
    {
      id: 4,
      senderType: "support",
      senderName: "Support Agent A",
      message: "Issue has been fixed. Please try again now.",
      date: "2025-01-06",
      time: "02:10 PM",
    },
  ];

  // ================= MESSAGE TIMELINE =================
  const MessageTimeline = ({ messages }) => (
    <div className="mt-3">
      {messages.map(msg => (
        <div
          key={msg.id}
          className={`d-flex mb-4 ${
            msg.senderType === "client"
              ? "justify-content-start"
              : "justify-content-end"
          }`}
        >
          <div
            className={`p-3 rounded shadow-sm ${
              msg.senderType === "client"
                ? "bg-light border"
                : "bg-primary text-white"
            }`}
            style={{ maxWidth: "70%" }}
          >
            <div className="fw-bold mb-1">
              {msg.senderName}
            </div>

            <div className="mb-2">
              {msg.message}
            </div>

            <div className="small text-muted text-end">
              {msg.date} • {msg.time}
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  // ================= UI =================
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>

          <Breadcrumbs
            title={props.t("Clients")}
            breadcrumbItem={props.t("Messages")}
          />

          <ClientMenu />

          <Card>
            <CardBody>
              <h5 className="mb-3">Client Messages</h5>

              <MessageTimeline messages={messages} />

            </CardBody>
          </Card>

        </Container>
      </div>
    </React.Fragment>
  );
};

ClientMessages.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(ClientMessages);
